import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faLightbulb,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import "./TrainingPopup.css";

const TrainingPopup = ({
  tip,
  onClose,
  onDismiss,
  targetElement = null,
  position = "bottom", // 'top', 'bottom', 'left', 'right', 'center'
}) => {
  const popupRef = useRef(null);

  useEffect(() => {
    if (tip && targetElement && popupRef.current) {
      positionPopup();
    }
  }, [tip, targetElement, position]);

  const positionPopup = () => {
    if (!targetElement || !popupRef.current) return;

    const popup = popupRef.current;
    const target = targetElement;
    const targetRect = target.getBoundingClientRect();
    const popupRect = popup.getBoundingClientRect();

    let top, left;

    switch (position) {
      case "top":
        top = targetRect.top - popupRect.height - 10;
        left = targetRect.left + (targetRect.width - popupRect.width) / 2;
        break;
      case "bottom":
        top = targetRect.bottom + 10;
        left = targetRect.left + (targetRect.width - popupRect.width) / 2;
        break;
      case "left":
        top = targetRect.top + (targetRect.height - popupRect.height) / 2;
        left = targetRect.left - popupRect.width - 10;
        break;
      case "right":
        top = targetRect.top + (targetRect.height - popupRect.height) / 2;
        left = targetRect.right + 10;
        break;
      case "center":
      default:
        top = window.innerHeight / 2 - popupRect.height / 2;
        left = window.innerWidth / 2 - popupRect.width / 2;
        break;
    }

    // Ensure popup stays within viewport
    const margin = 10;
    top = Math.max(
      margin,
      Math.min(top, window.innerHeight - popupRect.height - margin)
    );
    left = Math.max(
      margin,
      Math.min(left, window.innerWidth - popupRect.width - margin)
    );

    popup.style.position = "fixed";
    popup.style.top = `${top}px`;
    popup.style.left = `${left}px`;
    popup.style.zIndex = "10000";
  };

  if (!tip) return null;

  return (
    <div className="training-overlay">
      <div
        ref={popupRef}
        className={`training-popup ${position}`}
        data-tip-id={tip.id}
      >
        <div className="training-popup-header">
          <div className="training-popup-title">
            <FontAwesomeIcon icon={faLightbulb} className="tip-icon" />
            <span>{tip.title}</span>
          </div>
          <button
            className="training-popup-close"
            onClick={onClose}
            aria-label="Close tip"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="training-popup-content">
          <p>{tip.content}</p>
          {tip.action && (
            <div className="training-popup-action">
              <strong>Try this:</strong> {tip.action}
            </div>
          )}
        </div>

        <div className="training-popup-footer">
          <button className="training-popup-button secondary" onClick={onClose}>
            Skip
          </button>
          <button
            className="training-popup-button primary"
            onClick={() => onDismiss(tip.id)}
          >
            <FontAwesomeIcon icon={faCheck} />
            Got it!
          </button>
        </div>

        {/* Arrow for positioning */}
        {position !== "center" && (
          <div className={`training-popup-arrow ${position}`}></div>
        )}
      </div>
    </div>
  );
};

export default TrainingPopup;
